import {ReactNode} from 'react';

import {Add, Edit} from '@mui/icons-material';
import {Box, IconButton, SxProps} from '@mui/material';

import {greenColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  children: ReactNode;
  sx?: SxProps;
  onEdit?: () => void;
  onAdd?: () => void;
  testid?: string;
}

export const Editable = ({children, sx, testid, ...props}: Props) => {
  const iconColor = greenColors[100];
  const hasAction = Boolean(props.onEdit || props.onAdd);
  return (
    <Box sx={{position: 'relative', mt: 10, pr: hasAction ? '48px' : 0, ...sx}}>
      {props.onAdd && (
        <IconButton
          onClick={props.onAdd}
          data-testid={testid || 'add'}
          name='add'
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            zIndex: 1,
          }}
        >
          <Add width={24} height={24} sx={{color: iconColor}} />
        </IconButton>
      )}
      {props.onEdit && (
        <IconButton
          data-testid={testid || 'edit'}
          onClick={props.onEdit}
          sx={{
            position: 'absolute',
            top: props.onAdd ? 60 : 6,
            right: 0,
            zIndex: 1,
          }}
        >
          <Edit width={24} height={24} sx={{color: iconColor}} />
        </IconButton>
      )}
      {children}
    </Box>
  );
};
